import React from 'react';
import './headeritem.css'

const Navitem = (props) => {
    return ( <>
        <a className='headeritem' href={props.link}>{props.title}</a>
    </> );
}
 
export default Navitem;